import { render, staticRenderFns } from "./UserKnowledge.vue?vue&type=template&id=7d390b04&scoped=true&"
import script from "./UserKnowledge.vue?vue&type=script&lang=js&"
export * from "./UserKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./UserKnowledge.vue?vue&type=style&index=0&id=7d390b04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d390b04",
  null
  
)

export default component.exports